import { mui, React, ts, ui } from '_core';

type SpPipelineFieldProps = {
  dataset: ts.types.signal.DatasetDraft;
  setDataset: (_d: ts.types.signal.DatasetDraft) => void;
  isPreference?: boolean;
};

const SpPipelineField = ({ dataset, setDataset, isPreference }: SpPipelineFieldProps) => {
  return (
    <mui.core.Grid container spacing={2} style={{ flexWrap: 'nowrap' }} alignItems="center">
      <mui.core.Grid size="grow">
        <ui.ResourceAutocomplete<ts.types.pipeline.PipelineExpanded>
          enableNone
          value={dataset.sp_pipeline_id}
          setValue={(id) =>
            setDataset({
              ...dataset,
              sp_pipeline_id: id,
              id: isPreference ? dataset?.id : null,
            })
          }
          type="sp_pipeline"
          inputProps={{
            fullWidth: true,
            label: 'Portfolio Pipeline',
            variant: 'outlined',
            size: 'small',
          }}
        />
      </mui.core.Grid>
    </mui.core.Grid>
  );
};

export default SpPipelineField;
